module.exports = __webpack_public_path__ + "static/img/baoyang.4181fa93.png";